module.exports = __webpack_public_path__ + "static/media/1.78435249.png";